var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deactivation-comment"},[_c('Input',{attrs:{"name":"comment","placeholder":_vm.$t((_vm.tPrefix + ".inputPlaceholder")),"value":_vm.comment,"multiline":true,"maxlength":1024},on:{"input":_vm.changeComment}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }